<template>
	<div id="keyPersonnel" class="oh">
		<table border="0" cellspacing="0" cellpadding="0" class="pagetable1 fl" style="width: 100%;">
			<tr>
				<th>序号</th>
				<th>姓名</th>
				<th>职务</th>
				<th>持股比例</th>
			</tr>
			<tr :key="ind" v-for="(list, ind) in keyPersonalList">
				<td>{{ ind + 1 }}</td>
				<td>{{ list.name }}</td>
				<td>{{ list.position }}</td>
				<td>{{ list.value== 0?'-':list.value+'%' }}</td>
			</tr>
		</table>
	</div>
</template>

<script>
import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"

export default {
	name: 'keyPersonnel',
	data() {
		return {
			titleh: "企业详情页--主要人员",
			echartWidth2: document.body.offsetWidth * 0.8728 * 0.95 * 0.48,
		}
	},
	props: {
		keyPersonalList: { type: Array, default: () => [] },
		isFree: {
			type: Boolean,
			default: false
		},
	},
	components: { freeUserTips },
	created() {
	},
	mounted() {
	},
	methods: {

	}
};
</script>

<style lang="scss" scoped>
.pagetable1 {
	margin-bottom: 20px;
}

.endsm_title1 {
	border-left: 8px solid #3e7bfa;
	line-height: 20px;
	padding-left: 14px;
	margin: 30px 0 30px;
}

#mainPieProduct,
#mainPieArea,
#mainPieHy {
	width: 30%;
	height: 400px;
	background: #fff;
	border: 1px solid #eee;
}

.curTableDate {
	width: 150px;
	margin-left: 100px;
}

.container-flex-center img {
	max-width: 95%;
	max-height: 95%;
}

.el-dialog__headerbtn {
	font-size: 30px;
	font-weight: bold;
}

.pop-box {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	border: 1px solid red;
	z-index: 99999;
}

.market-list {
	width: calc(33% - 35px);
	height: 365px;
	cursor: pointer;
	overflow: hidden;
	transition: all .3s;
	border: 1px solid #eee;
	margin-right: 35px;
	border-radius: 8px;
}

.market-list:hover {
	/* background: #f3f7ff; */
	border-radius: 8px;

}

.image-card {
	height: 270px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.market-title {
	padding: 20px 20px 0 20px;
	height: 48px;
	/* display: flex; */
	/* align-items: center; */
	/* overflow: hidden; */
}

.font-size14 {
	font-size: 14px;
}
</style>